import axios from 'axios';
import config from '../../../config';

const authClient = axios.create({
  baseURL: `https://${config.BACKEND}:${config.PORT}/users`,
});

export function loginWithCredentials({ email, password }) {
  return authClient.post('/login', { email, password });
}

export function registerUser(payload) {
  return authClient.post('/register', payload);
}
